<main class="_modal0" (click)="m($event);false">

</main>
<main class="_modal">
  <div class="modal-container">

    <app-theme-page-container [label]="title" [canNavigateBack]="true" (onBack)="goBack()" logo="elogbooks">
      @if (sites && !site) {
        <app-theme-page-section>
          <table class="table table-hover can-click">
            <thead>
              <tr>
                <th>Site </th>
                <th></th>
                <th colspan="3">Address</th>
              </tr>
            </thead>
            <tbody>
              @for (site of sites; track site) {
                <tr (click)="siteClick(site)">
                  <td>{{site.id}}</td>
                  <td>{{site.name}}</td>
                  <td>{{site.address?.line1}}</td>
                  <td>{{site.address?.town}}</td>
                  <td>{{site.address?.postcode}}</td>
                </tr>
              }
            </tbody>
          </table>
        </app-theme-page-section>
      }
      @if (priorities) {
        <app-theme-page-section>
          <table class="table table-hover can-click">
            <thead>
              <tr>
                <th>Priority </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (priority of priorities; track priority) {
                <tr (click)="priorityClick(priority)">
                  <td>{{priority.id}}</td>
                  <td>{{priority.name}}</td>
                </tr>
              }
            </tbody>
          </table>
        </app-theme-page-section>
      }
      @if (site) {
        <app-theme-page-section>
          <article>
            <p><span>Purchase Order Required</span>{{site.poRequired}}</p>
            <p><span>Planned Job Approval Required</span>{{site.plannedJobApprovalRequired}}</p>
            <p><span>Reactive Job Approval Required</span>{{site.reactiveJobApprovalRequired}}</p>
            @for (w of webhooks; track w) {
              <p>
                <span>Webhook Active</span> {{w.active}}
              </p>
              {{w.url}}
            }
            <button class="btn btn-secondary btn-block mt-1" (click)="site=null;webhooks=[]">Cancel</button>
            <button class="btn btn-primary btn-block mt-1" (click)="selectSite()">Select</button>
          </article>
        </app-theme-page-section>
      }
    </app-theme-page-container>
  </div>
  @if (isLoading) {
    <app-please-wait></app-please-wait>
  }
</main>
